import WebFontLoader from 'webfontloader'

// async load fonts
WebFontLoader.load({
  google: {
    families: [
      'Newsreader:500,600&display=swap',
      'Public+Sans:400,500,600,700&display=swap',
    ],
  },
})
